import { IEmployee, EmployeesService, EnumService, TwinfieldService } from "../../../services/index";

class EmployeesListController {
    inProgress: boolean;
    emailaddresses: string;
    private currentPage: number;
    private itemsPerPage: number;
    private sortType: string;
    private search: string;
    private tag: string;
    private statusFilter: string;
    private accountingFilter: string;
    private employees: IEmployee[];
    private filteredEmployees: IEmployee[];
    private sortReverse = false;

    constructor(
        private EmployeesService: EmployeesService,
        private EnumService: EnumService,
        private $stateParams: ng.ui.IStateParamsService,
        private $scope: any,
        private $filter: any,
        private $state: ng.ui.IStateService,
        private TwinfieldService: TwinfieldService
    ) {
        'ngInject';
        //console.log(EnumService);
        this.sortType = 'displayName';
        //console.log('EmployeesListController');

      
    }

    public $onInit = () => {

        /** Set return URI */

        this.TwinfieldService.setTwinfieldRedirectUri();
        
        this.currentPage = 1;
        this.itemsPerPage = 11;
        this.getEmployees();
        // this.$scope.$watch(() => {
        //     return this.filteredEmployees;
        // }, () => {
        //     this.emailToClipboard();
        // });
    }
    public onCopySuccess = (e) => {
        alert('Gegevens gekopieerd naar plakbord!')
    }

    public getEmployees = () => {

        if (this.statusFilter === 'inactive') {
            this.EmployeesService.getEmployeesByStatus(false).then(res => {
                this.employees = res;
                this.applyFilters();
            })
        } else {
            this.EmployeesService.getEmployeesByStatus().then(res => {
                this.employees = res;
                this.applyFilters();
            })
        }
    }

    applyFilters() {

        console.log(this.sortType);
        this.filteredEmployees = this.$filter('filter')(this.employees, this.tag);
        this.filteredEmployees = this.$filter('filterBy')(this.filteredEmployees, ['displayName', 'functionName', 'homeAddressCity'], this.search);
        this.filteredEmployees = this.$filter('orderBy')(this.filteredEmployees, this.sortType);
        if (this.accountingFilter === 'nmbrs') {
            this.filteredEmployees = this.filteredEmployees.filter(e => e.nmbrsId);
        }
        if (this.accountingFilter === 'zzp') {
            this.filteredEmployees = this.filteredEmployees.filter(e => !e.nmbrsId);
        }
        // ($ctrl.employees | filter: $ctrl.tag | filterBy : ['displayName', 'functionName', 'emailPrivate']: $ctrl.search | orderBy:$ctrl.sortType:sortReverse)

        this.emailToClipboard();
    }

    emailToClipboard() {
        if (this.filteredEmployees.length > 0) {
            var emailsList = [];
            this.filteredEmployees.forEach((e, i) => {
                if (e.emailPrivate) {
                    emailsList.push(e.emailPrivate);
                }
            });
            this.emailaddresses = emailsList.join(';');
        }

        //console.log(emailsList.join(';'));
        //window.prompt("Ctrl+C to copy to clipboard, then paste in the BCC field of an email:", emailsList.join(';'));
    }

    refreshEmployeesNmbrs() {
        (<any>$('#notificationModal')).modal('show');
        this.inProgress = true;
        this.EmployeesService.refreshAll().then(() => {
            (<any>$('#notificationModal')).modal('hide');
            this.inProgress = false;
            this.$state.reload();
        })
    }

}

export const employeesListComponent = {
    bindings: {
    },
    controller: EmployeesListController,
    template: require('./employees.list.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/employees/employees.list.component.ts